const currencyFilter = ( value: string, symbol: string, position: string = 'end' ) => {
    const splitedValue = value.toString().split('.');
    const integer = splitedValue[0];
    const decimal = splitedValue[1];
    const formattedInteger = integer.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    let result = formattedInteger;
    if ( decimal ) {
        result = `${formattedInteger},${decimal}`;
    }
    if (position === 'end') {
        result = `${result} ${symbol}`;
    } else {
        result = `${symbol} ${result}`;
    }
    return result;
};

export default currencyFilter;
